import {
  EmptyState,
  Section,
  TitleAndDescription,
} from '@angeplus/prever-component-lib';
import { ContactUsIllustration } from 'components/illustration/ContactUsIllustration';
import { useWhatsappApi } from 'utils/useWhatsappApi';

export const PetAssistanceBenefit = () => {
  const { handleSendWhatsappMessage } = useWhatsappApi({
    phone: '+551132882526',
    text: 'Olá, gostaria de informações sobre Assistência Pet.',
  });

  return (
    <Section>
      <TitleAndDescription
        title="Acionar Assistência Pet"
        description="Tenha acesso a assistências como cremação, teleconsultas veterinárias, urgência e emergência. Para utilizar este benefício, entre em contato com a Central de Atendimento."
      />
      <EmptyState
        illustration={<ContactUsIllustration />}
        buttonLabelPrimary="Entrar em contato pelo Whatsapp"
        onClickButtonPrimary={handleSendWhatsappMessage}
      />
    </Section>
  );
};
